"use strict";
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  chainId: null,
  openModal: null,
  suppressedPopups: [],
  downloadGraduatedWalletCardsDismissed: []
};
const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    updateDownloadGraduatedWalletCardsDismissed(state, { payload: { walletAddress } }) {
      state.downloadGraduatedWalletCardsDismissed = Array.from(
        /* @__PURE__ */ new Set([...state.downloadGraduatedWalletCardsDismissed, walletAddress])
      );
    },
    updateChainId(state, action) {
      const { chainId } = action.payload;
      state.chainId = chainId;
    },
    setOpenModal(state, action) {
      state.openModal = action.payload;
    },
    setCloseModal(state, action) {
      const { payload } = action;
      if (!payload || state.openModal?.name === payload) {
        state.openModal = null;
      }
    },
    addSuppressedPopups(state, { payload: { popupTypes } }) {
      state.suppressedPopups = Array.from(/* @__PURE__ */ new Set([...state.suppressedPopups, ...popupTypes]));
    },
    removeSuppressedPopups(state, { payload: { popupTypes } }) {
      state.suppressedPopups = state.suppressedPopups.filter((type) => !popupTypes.includes(type));
    }
  }
});
export const {
  updateChainId,
  setOpenModal,
  setCloseModal,
  addSuppressedPopups,
  removeSuppressedPopups,
  updateDownloadGraduatedWalletCardsDismissed
} = applicationSlice.actions;
export default applicationSlice.reducer;
